const PROJECTS_DATA = [
  {
    id: 1,
    title: "Bijin Carte",
    titleImg: "https://res.cloudinary.com/dtewjoisz/image/upload/v1600917543/projects/bc_title_cover_xc0lja.png",
    imagesUrls: ["https://res.cloudinary.com/dtewjoisz/image/upload/v1600916521/projects/bc_home_ioqnnq.png", "https://res.cloudinary.com/dtewjoisz/image/upload/v1600916521/projects/bc_about_gf6cad.png", "https://res.cloudinary.com/dtewjoisz/image/upload/v1600916521/projects/bc_shindan_btxcjv.png", "https://res.cloudinary.com/dtewjoisz/image/upload/v1600916530/projects/bc_shindan_result_gympoj.png", "https://res.cloudinary.com/dtewjoisz/image/upload/v1600916522/projects/bc_shindan_result_3_u8mnpa.png", "https://res.cloudinary.com/dtewjoisz/image/upload/v1600916522/projects/bc_lessons_lfbhhv.png", "https://res.cloudinary.com/dtewjoisz/image/upload/v1600916522/projects/bc_lessons_details_khpsci.png", "https://res.cloudinary.com/dtewjoisz/image/upload/v1600916522/projects/bc_faq_fil3df.png"],
    description: "Freelance project. The client requested a website with a content manager for her side business. Followed the specific design requests from the client.",
    specifications: "Solo project | 1 Month",
    links: [
      {
        id: 1,
        title: "github",
        url: "https://github.com/noemi-ashizuka/bijin_carte"
      },
      {
        id: 2,
        title: "website",
        url: "https://bijin-carte.com"
      },
      {
        id: 3,
        title: "video",
        url: "/"
      }
    ],
    technologies: [
      {name: "Gatsby JS", iconUrl: ""},
      {name: "React JS", iconUrl: ""},
      {name: "HTML", iconUrl: ""},
      {name: "SCSS", iconUrl: ""},
      {name: "JavaScript", iconUrl: ""},
      {name: "Wordpress", iconUrl: ""},
      {name: "GraphQL", iconUrl: ""}
    ]
  },
  {
    id: 2,
    title: "Clever Closet",
    titleImg: "https://res.cloudinary.com/dtewjoisz/image/upload/v1591347933/website-resized/cover2_v4jalr.png",
    imagesUrls: ["https://res.cloudinary.com/dtewjoisz/image/upload/v1591347933/website-resized/cc_home_pbgd4p.png", "https://res.cloudinary.com/dtewjoisz/image/upload/v1591347933/website-resized/cc_profile_hwcmzn.png", "https://res.cloudinary.com/dtewjoisz/image/upload/v1591347932/website-resized/cc_look_c2qsbz.png", "https://res.cloudinary.com/dtewjoisz/image/upload/v1591347932/website-resized/cc_friends_fvkob0.png", "https://res.cloudinary.com/dtewjoisz/image/upload/v1591347933/website-resized/cc_new_look_usosyb.png", "https://res.cloudinary.com/dtewjoisz/image/upload/v1591347932/website-resized/cc_closet_rscwak.png"],
    specifications: "Group project | Role: team manager | Time: 2 weeks",
    description: "Clever Closet is an app to manage your wardrobe and help reduce the impact of fast fashion on the environment. How does it do that? Simple, with Clever Clothes you can share clothes with friends, create looks for yourself and your friends to make the most out of the clothes you already own. For this project I was responsible for my team workflow, database design and user stories. I wrote code for the backend as well as the frontend.",
    links: [
        {
          id: 1,
          title: "github",
          url: "https://github.com/noemi-ashizuka/clever_closet"
        },
        {
          id: 2,
          title: "website",
          url: "https://clever-closet-main.herokuapp.com/"
        },
        {
          id: 3,
          title: "video",
          url: "/"
        }
      ],
      technologies: [
        {name: "Ruby", iconUrl: ""},
        {name: "Rails", iconUrl: ""},
        {name: "HTML", iconUrl: ""},
        {name: "SCSS", iconUrl: ""},
        {name: "JavaScript", iconUrl: ""},
        {name: "PostgreSQL", iconUrl: ""},
        {name: "Figma", iconUrl: ""},
        {name: "PWA", iconUrl: ""},
        {name: "Mobile First App", iconUrl: ""}
      ]
  },
  {
    id: 3,
    title: "Tokyo Best Coffee Shops",
    titleImg: "https://res.cloudinary.com/dtewjoisz/image/upload/v1591347933/website-resized/coffee_home_l0tdad.png",
    imagesUrls: ["https://res.cloudinary.com/dtewjoisz/image/upload/v1591347933/website-resized/coffee_home_l0tdad.png", "https://res.cloudinary.com/dtewjoisz/image/upload/v1591347933/website-resized/coffee_show_dmvlaw.png", "https://res.cloudinary.com/dtewjoisz/image/upload/v1591347933/website-resized/coffee_list_jfusmp.png", "https://res.cloudinary.com/dtewjoisz/image/upload/v1591347933/website-resized/coffee_api_f2101y.png"],
    specifications: "Solo project",
    description: "An app to create articles about the best coffee shops in Tokyo. It includes reviews and menus and any user can contribute and help others find hidden gems. It also includes an API with all the users coffee shops data .",
    links: [
      {
        id: 1,
        title: "github",
        url: "https://github.com/noemi-ashizuka/tokyo-best-coffee-shops"
      },
      {
        id: 2,
        title: "website",
        url: "https://tokyo-best-coffee-api.herokuapp.com/"
      },
      {
        id: 3,
        title: "video",
        url: "/"
      }
    ],
    technologies: [
      {name: "Ruby", iconUrl: ""},
      {name: "Rails", iconUrl: ""},
      {name: "HTML", iconUrl: ""},
      {name: "SCSS", iconUrl: ""},
      {name: "JavaScript", iconUrl: ""},
      {name: "PostgreSQL", iconUrl: ""},
      {name: "API", iconUrl: ""}
    ]
  },
  {
    id: 4,
    title: "Obi",
    titleImg: "https://res.cloudinary.com/dtewjoisz/image/upload/v1591347935/website-resized/obi_home_ac0squ.png",
    imagesUrls: ["https://res.cloudinary.com/dtewjoisz/image/upload/v1591347935/website-resized/obi_home_ac0squ.png","https://res.cloudinary.com/dtewjoisz/image/upload/v1591347933/website-resized/obi_dashnoe_rkid71.png","https://res.cloudinary.com/dtewjoisz/image/upload/v1591347934/website-resized/obi_listings_wxmywl.png", "https://res.cloudinary.com/dtewjoisz/image/upload/v1591347934/website-resized/obi_show_ttuhef.png"],
    specifications: "Group project | Role: team manager | Time: 1 week",
    description: "Obi is a marketplace where people can rent or lend kimonos of many different types. For this project I was responsible for database design, assigning tasks to the team, code reviews and coding for the backend as well as frontend.",
    links: [
      {
        id: 1,
        title: "github",
        url: "https://github.com/noemi-ashizuka/obi"
      },
      {
        id: 2,
        title: "website",
        url: "https://obi-kimono-rental.herokuapp.com/"
      },
      {
        id: 3,
        title: "video",
        url: "/"
      }
    ],
    technologies: [
      {name: "Ruby", iconUrl: ""},
      {name: "Rails", iconUrl: ""},
      {name: "HTML", iconUrl: ""},
      {name: "SCSS", iconUrl: ""},
      {name: "JavaScript", iconUrl: ""},
      {name: "SQLite", iconUrl: ""}
    ]
  },
  {
    id: 5,
    title: "Bartender Cocktail",
    titleImg: "https://res.cloudinary.com/dtewjoisz/image/upload/v1591347932/website-resized/bc_home_lvqvry.png",
    imagesUrls: ["https://res.cloudinary.com/dtewjoisz/image/upload/v1591347932/website-resized/bc_home_lvqvry.png", "https://res.cloudinary.com/dtewjoisz/image/upload/v1591347932/website-resized/bc_card_one_ulvune.png", "https://res.cloudinary.com/dtewjoisz/image/upload/v1591347932/website-resized/bc_list_kolgh3.png", "https://res.cloudinary.com/dtewjoisz/image/upload/v1591347932/website-resized/bc_card_two_xrpyju.png"],
    description: "Project for Le Wagon bootcamp. The purpose was to learn how to develop an app with complex databases relations. Users can create a cocktails using a list of ingredients.",
    specifications: "Solo project | Time: 2 days",
    links: [
      {
        id: 1,
        title: "github",
        url: "https://github.com/noemi-ashizuka/rails-mister-cocktail"
      },
      {
        id: 2,
        title: "website",
        url: "https://bartender-mister.herokuapp.com/"
      },
      {
        id: 3,
        title: "video",
        url: "/"
      }
    ],
    technologies: [
      {name: "Ruby", iconUrl: ""},
      {name: "Rails", iconUrl: ""},
      {name: "HTML", iconUrl: ""},
      {name: "SCSS", iconUrl: ""},
      {name: "JavaScript", iconUrl: ""},
      {name: "SQLite", iconUrl: ""}
    ]
  },
  {
    id: 6,
    title: "Sailor Maker",
    titleImg: "https://res.cloudinary.com/dtewjoisz/image/upload/v1591347935/website-resized/swm_home_eeqvsl.png",
    imagesUrls: ["https://res.cloudinary.com/dtewjoisz/image/upload/v1591347935/website-resized/swm_home_eeqvsl.png", "https://res.cloudinary.com/dtewjoisz/image/upload/v1591347935/website-resized/swm_card_enauin.png", "https://res.cloudinary.com/dtewjoisz/image/upload/v1591347939/website-resized/swm_list_i7eown.png", "https://res.cloudinary.com/dtewjoisz/image/upload/v1591347936/website-resized/swm_card_two_gmxno4.png"],
    description: "Le Wagon weekend challenge. I decided to go for something I am passionate about and created an app where people can upload their own Sailor Scouts and choose powers for them.",
    specifications: "Solo project | Time: 2 days",
    links: [
      {
        id: 1,
        title: "github",
        url: "https://github.com/noemi-ashizuka/rails-sailor-maker"
      },
      {
        id: 2,
        title: "website",
        url: "https://sailor-warrior-maker.herokuapp.com/"
      },
      {
        id: 3,
        title: "video",
        url: "/"
      }
    ],
    technologies: [
      {name: "Ruby", iconUrl: ""},
      {name: "Rails", iconUrl: ""},
      {name: "HTML", iconUrl: ""},
      {name: "SCSS", iconUrl: ""},
      {name: "JavaScript", iconUrl: ""},
      {name: "PostgreSQL", iconUrl: ""}
    ]
  }
]

export default PROJECTS_DATA;